import { Alert, Button, Center, Loader, Stack, Text } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { errorMessage } from '../../utils/errors.js';

/**
 * The grid's own loading and error chrome, shared by Studios and Games: a centered loader while
 * the first page is in flight, or — only while there are no rows to show instead — a "could not
 * load" alert with Retry. Once rows are on screen, a refetch failure is not this component's job
 * to report (the page keeps showing what it has).
 */
export const MatrixLoadState = ({
    isLoading,
    isError,
    error,
    onRetry,
    label,
}: {
    isLoading: boolean;
    /** Whether the failed load left nothing on screen — the caller decides (`isError && rows.length === 0`). */
    isError: boolean;
    error: unknown;
    onRetry: () => void;
    /** "studios" / "games" — the failure title's noun, lower case. */
    label: string;
}) => (
    <>
        {isLoading && (
            <Center p="xl">
                <Loader />
            </Center>
        )}

        {isError && (
            <Alert
                color="red"
                icon={<IconAlertTriangle size={16} stroke={1.7} />}
                title={`Could not load the ${label}`}
            >
                <Stack gap="xs" align="flex-start">
                    <Text fz="sm">{errorMessage(error)}</Text>
                    <Button variant="light" size="xs" onClick={onRetry}>
                        Retry
                    </Button>
                </Stack>
            </Alert>
        )}
    </>
);
